import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function requestAdminUsageReport({
  firebaseFunctions = functions,
  rangeDays = 30,
  rangePreset = '',
  userId = '',
} = {}) {
  const getUsageReport = httpsCallable(firebaseFunctions, 'getAdminUsageReport');
  const payload = rangePreset ? { rangePreset } : { rangeDays };
  if (userId) payload.userId = userId;
  const result = await getUsageReport(payload);
  return result.data;
}
